import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FormSocialAuditComponent } from './form-social-audit.component';

const routes: Routes = [
    {
        path: '',
        component: FormSocialAuditComponent,

    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class FormSocialAuditRoutingModule { }
